import {DefaultTheme} from 'styled-components';

import {ChartToolbarHighlights} from '../types/ChartToolbarHighlight';
import {ExtendedStatisticsCar} from '../types/ExtendedStatisticsCar';
import {isNewVehicleInAdvertisement} from './isNewVehicleInAdvertisement';
import {isVehicleMatchingSelectedSeller} from './isVehicleMatchingSelectedSeller';

interface ScatterDotStroke {
  stroke?: string;
  strokeOpacity?: number;
  strokeWidth?: number;
}

interface GetScatterDotStrokeParams {
  theme: DefaultTheme;
  car: ExtendedStatisticsCar | undefined;
  highlights: ChartToolbarHighlights;
  isMyAd: boolean;
  selectedSellerId: string | null;
}

export function getScatterDotStroke(params: GetScatterDotStrokeParams): ScatterDotStroke {
  const showDealerBorder =
    params.car !== undefined &&
    isVehicleMatchingSelectedSeller(params.car, params.selectedSellerId);
  const showSuspiciousBorder = params.highlights.suspicious && params.car?.suspicious === true;
  const showNewBorder =
    params.highlights.new && params.car !== undefined && isNewVehicleInAdvertisement(params.car);

  if (params.isMyAd) {
    return {
      stroke: params.theme.colors.palettes.green['40']['100'],
      strokeOpacity: 0.4,
      strokeWidth: 16,
    };
  }

  if (showDealerBorder) {
    return {
      stroke: params.theme.colors.palettes.blue['60']['100'],
      strokeOpacity: 1,
      strokeWidth: 2,
    };
  }

  if (showSuspiciousBorder) {
    return {
      stroke: params.theme.colors.severity.danger,
      strokeOpacity: 1,
      strokeWidth: 2,
    };
  }

  if (showNewBorder) {
    return {
      stroke: params.theme.colors.palettes.green['60']['100'],
      strokeOpacity: 1,
      strokeWidth: 2,
    };
  }

  return {};
}
